module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container payment main"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "p-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.32rem"
    }
  }, [_vm._v("\n          支付剩余时间 " + _vm._s(_vm.minutes) + ":" + _vm._s(_vm.seconds) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "amount"
  }, [_vm._v("\n          ￥"), _c('span', [_vm._v(_vm._s(_vm.details.amount))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.details.shopName) + "-" + _vm._s(_vm.details.orderId))])]), _vm._v(" "), _c('div', {
    staticClass: "p-card"
  }, [_c('div', {
    staticClass: "payment-list"
  }, [_c('ul', {
    staticClass: "list"
  }, [_vm._l((_vm.details.paywayList), function(item, index) {
    return (
      _vm.client_type != '11' &&
      (item.payway_id == 3 ||
        item.payway_id == 5 ||
        item.payway_id == 20 ||
        item.payway_id == 41)
    ) ? _c('li', {
      key: index,
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.selected(item.payway_id)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "height": "100%",
        "justify-content": "center"
      }
    }, [_c('div', {
      staticClass: "pay_logo"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.recommendInfo) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, [_vm._v("\n                  " + _vm._s(item.recommendInfo) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.recommendInfoList) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, _vm._l((item.recommendInfoList), function(info) {
      return _c('span', [_vm._v(_vm._s(info.recommendInfo) + ";")])
    }), 0) : _vm._e()]), _vm._v(" "), (item.payway_id == 20 && !_vm.cardSchoolIds.includes(_vm.schoolId)) ? _c('span', {
      staticClass: "card-detail",
      on: {
        "click": _vm.cardDetail,
        "touchmove": function($event) {
          $event.preventDefault();
        }
      }
    }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), _c('div', {
      class: ['pay_icon', {
        on: item.selected
      }]
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.details.paywayList), function(item) {
    return (_vm.client_type == '11' && item.payway_id == 31) ? _c('li', {
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.selected(item.payway_id)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "height": "100%",
        "justify-content": "center"
      }
    }, [_c('div', {
      staticClass: "pay_logo"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.recommendInfo) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, [_vm._v("\n                  " + _vm._s(item.recommendInfo) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.recommendInfoList) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, _vm._l((item.recommendInfoList), function(info) {
      return _c('span', [_vm._v(_vm._s(info.recommendInfo) + ";")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
      class: ['pay_icon', {
        on: item.selected == true
      }]
    })]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-white fixed fixed-bottom"
  }, [_c('button', {
    staticClass: "btn btn-yellow btn-confirm",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.confirmPay
    }
  }, [_vm._v("\n        立即支付\n      ")])])]), _vm._v(" "), (_vm.isShowAuth) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowAuth = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowAuth) ? _c('div', {
    staticClass: "alert-box",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("还未授权校园卡")]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow authBtn",
    on: {
      "click": function($event) {
        return _vm.toAutn()
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n      立即授权\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("为保证卡片安全会不定期重新授权")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.isShowAuth = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo) ? _c('div', {
    staticClass: "alert-box",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("校园卡信息")]), _vm._v(" "), _c('p', {
    staticClass: "des desInfo"
  }, [_vm._v("卡号：" + _vm._s(_vm.schoolCardCode))]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow authBtn sureBtn",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n      确定\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo1) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo1 = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo1) ? _c('div', {
    staticClass: "alert-box school-card",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("请输入账号" + _vm._s(_vm.paymentDetail.campusAuthType === 0 ? '和密码' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("工号/学号：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolCard.accNum),
      expression: "schoolCard.accNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入工号/学号"
    },
    domProps: {
      "value": (_vm.schoolCard.accNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.schoolCard, "accNum", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.paymentDetail.campusAuthType === 0 || _vm.paymentDetail.campusAuthType === 2) ? _c('div', {
    staticClass: "input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("密码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolCard.password),
      expression: "schoolCard.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.schoolCard.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.schoolCard, "password", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow authBtn sureBtn",
    on: {
      "click": function($event) {
        return _vm.submitSchoolCardForm()
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n      去支付\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo1 = false
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4cc2e018","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Payment.vue
// module id = 437
// module chunks = 7